import React from "react";
import "./Experience.css";
import CardContains from "../CardContains";

export default function Experience() {
  return (
    <div className="experience-card">
      <CardContains
        InstitutionName={
          "Internal Hackathon for SIH (Smart India Hackathon) | Team LeadUnity | Vuforia | Python"
        }
        DegreeDetails={
          "Worked on Unity and Vuforia to project models on the target Images for the AR app to visualize 3D models of different Heritage sites.                                      Built the multilanguage Support for the App."
        }
        Year={"Jan 2022 - Feb 2023"}
      />
      <CardContains
        InstitutionName={"CODEDAMN | Technical Content Writer"}
        DegreeDetails={
          "Wrote technical blog using WordPress on several topics like C++, DSA, JAVA, JavaScript"
        }
        Year={"Jan 2023 - Mar 2023 "}
      />
    </div>
  );
}
